import React, { useContext, useEffect, useState } from "react";
import { AccountContext } from "../../Contexts/main.context";
import { jwtDecode } from "jwt-decode";

const ClientViewLocations = ({ setView }) => {
    const [locations, setLocations] = useState([]);
    const [clientData, setClientData] = useState([]);
    const { clientActiveLocation, updateClientActiveLocation } = useContext(AccountContext);

    useEffect(() => {
        const token = localStorage.getItem("LGOUser");
        if (token) {
            const getLocations = async (ID) => {
                try {
                    const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/client.php", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ script: "getLocations", clientID: ID }),
                    });

                    const data = await response.json();
                    setClientData(data.client);
                    setLocations(data.locations);

                    if (!clientActiveLocation || Object.keys(clientActiveLocation).length === 0) {
                        updateClientActiveLocation(data.locations[0]);
                    }
                } catch (err) {
                    console.error("Fetch error:", err);
                    setLocations([]);
                    setClientData([]);
                    updateClientActiveLocation([]);
                }
            };

            const decoded = jwtDecode(token);
            setClientData(decoded);
            const ID = decoded.clientAccount;
            getLocations(ID);
        }
    }, []);

    const handleLocationClick = (location) => {
        updateClientActiveLocation(location);
        setView('citations');
    };

    return (
        <div className="container-fluid rounded-2">
            <div className="p-2 text-center fs-5 text-navy fw-bold mb-2">
                Viewing Locations for <strong>{clientData.companyName}</strong>
            </div>

            <div className="d-flex flex-wrap gap-2 justify-content-center">
                {locations.map((location, index) => (
                    <div
                        key={index}
                        className={`location-card p-2 col-11 mb-3 ${location.ID === (clientActiveLocation?.ID) ? 'bg-navy' : 'bg-primary'}`}
                        style={{ minWidth: "300px", maxWidth: "400px", borderRadius: "10px", cursor: "pointer" }}
                        onClick={() => handleLocationClick(location)}
                    >
                        <div className="text-center fw-bold h5 text-white mt-2">{location.companyName}</div>
                        <div className="fs-6 text-center fw-bold text-lemon mb-1">{location.theLocation}</div>
                        <div className="fs-6 text-center text-white">{location.city}, {location.province}</div>
                        <div className="fs-6 text-center text-white">{location.postal}</div>
                        <div className="w-100 p-1">
                            <div className="text-center h5 text-white">
                                {location.citationCount} <span className="fs-8">Citations</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ClientViewLocations;
